function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import PropTypes from 'prop-types';
import ThemeContext from '../theme_context';
import createTheme from '../create_theme';
import SystemProvider from '../system_provider';
import SystemContext from '../system_context';
import { jsx as ___EmotionJSX } from "@emotion/core";
function ThemeProvider(props) {
  var {
    children,
    customSystem: customSystemProp,
    density: densityProp,
    mode: modeProp,
    shape: shapeProp,
    theme = {}
  } = props;
  var {
    customSystem: existingCustomSystem
  } = React.useContext(SystemContext);
  var customSystem = customSystemProp || existingCustomSystem;
  var contextOptions = React.useContext(ThemeContext);
  var options = React.useMemo(() => {
    var themeProps = {
      density: densityProp || contextOptions.density,
      mode: modeProp || contextOptions.mode,
      shape: shapeProp || contextOptions.shape
    };
    return _extends({}, themeProps, {
      theme: createTheme(_extends({}, themeProps, {
        outerTheme: theme,
        customSystem
      }))
    });
  }, [contextOptions, customSystem, densityProp, modeProp, shapeProp, theme]);
  return ___EmotionJSX(ThemeContext.Provider, {
    value: options
  }, ___EmotionJSX(SystemProvider, {
    customSystem: customSystem
  }, children));
}
ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
  density: PropTypes.oneOf(['standard', 'high']),
  mode: PropTypes.oneOf(['contrast', 'dark', 'light']),
  shape: PropTypes.oneOf(['round', 'sharp'])
};
ThemeProvider.defaultProps = {
  density: undefined,
  mode: undefined,
  shape: undefined
};
export default ThemeProvider;